import { ApiRoutes } from "consts/enpoints/api";
import { fetchApi } from "infrastructure/api";

export const getNotificationChannels = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetNotificationChannels}${queryString}`);
